import './styles.sass';

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import * as QueryFetcher from 'components/Explorer/models/query_fetcher';
import useQueryParams from 'hooks/useQueryParams';

const SaveSearch = ({ endpoint, analyticsName }) => {
  const params = useQueryParams();
  const filtersKey = JSON.stringify(params.filters);
  // Tracks the filtersKey that was current when the in-flight save was kicked
  // off. If filters change before the POST resolves we drop the result so a
  // stale save can't incorrectly mark the new search as saved/failed.
  const currentKeyRef = useRef(filtersKey);
  currentKeyRef.current = filtersKey;

  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [failed, setFailed] = useState(false);

  // Reset save state when filters change so the user can re-save the new search.
  useEffect(() => {
    setSaved(false);
    setSaving(false);
    setFailed(false);
  }, [filtersKey]);

  const saveSearch = () => {
    Analytics.trackEvent('Search Saved', { location: analyticsName });
    setSaving(true);
    const requestKey = filtersKey;

    QueryFetcher.saveSearch(params, endpoint)
      .then(() => {
        if (currentKeyRef.current !== requestKey) return;
        setSaved(true);
        setSaving(false);
      })
      .catch(() => {
        if (currentKeyRef.current !== requestKey) return;
        setFailed(true);
        setSaving(false);
      });
  };

  if (window.current_user.librarian || window.current_user.ip_user) return null;

  if (failed) {
    return (
      <button onClick={saveSearch} disabled className="SaveSearch failed">
        {I18n.t('Explorer.SaveSearch.failed')}
      </button>
    );
  }

  if (saved) {
    return (
      <button onClick={saveSearch} disabled className="SaveSearch saved">
        {I18n.t('Explorer.SaveSearch.complete')}
      </button>
    );
  }

  if (saving) {
    return (
      <button onClick={saveSearch} disabled className="SaveSearch saving">
        {I18n.t('Explorer.SaveSearch.progress')}
      </button>
    );
  }

  return (
    <button onClick={saveSearch} className="SaveSearch save">
      {I18n.t('Explorer.SaveSearch.action')}
    </button>
  );
};

SaveSearch.propTypes = {
  endpoint: PropTypes.string.isRequired,
  analyticsName: PropTypes.string.isRequired
};

export default SaveSearch;
